import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaUserResolver_GetDelegateId = UsersTableDefinitionZod.shape.delegateId.nullish();

export type SchemaUserResolver_GetDelegateId = z.infer<typeof schemaUserResolver_GetDelegateId>;

export type UserResolver_GetDelegateId = Resolver<Arguments, SchemaUserResolver_GetDelegateId>;
